import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import styles from './index.module.scss'
import { UiAppearance } from '~/modules/UiVariant/appearance'
import { toInternalMuseumHref } from '~/modules/Gallery/url'

interface Props {
  title: string
  gallery: string
  image?: string
  imagePosition?: string
  organizerAssetUrl?: string
  organizerName?: string
  appearance?: UiAppearance
  layout?: 'default' | 'galleryListing'
}

export const FeaturedGalleryCard: React.FC<Props> = ({
  title,
  image,
  gallery,
  imagePosition,
  organizerAssetUrl,
  organizerName,
  appearance = 'default',
  layout = 'default',
}) => {
  const router = useRouter()
  const href = toInternalMuseumHref(gallery)
  const isGalleryListing = layout === 'galleryListing'
  const containerClassName = [
    styles.featuredGalleryCard__container,
    appearance === 'museumHome' ? styles.museumHome : '',
    isGalleryListing ? styles.featuredGalleryCard__container_galleryListing : '',
  ].filter(Boolean).join(' ')
  const titleClassName = [
    styles.featuredGalleryCard__title,
    isGalleryListing ? styles.featuredGalleryCard__title_galleryListing : '',
  ].filter(Boolean).join(' ')
  const iconClassName = [
    styles.featuredGalleryCard__icon,
    isGalleryListing ? styles.featuredGalleryCard__icon_galleryListing : '',
  ].filter(Boolean).join(' ')

  return (
    <Link
      className={ styles.featuredGalleryCard__link }
      href={ href }
      locale={ router.locale }
      passHref={ true }
    >
      <div
        className={ containerClassName }
      >
        <img
          className={ styles.featuredGalleryCard__avatar }
          src={ image !== undefined && image !== null && image !== '' ? image : '/img/defaults/user.png' }
          alt={ title }
          style={ imagePosition !== undefined ? { objectPosition: imagePosition } : undefined }
        />

        {
          organizerAssetUrl && isGalleryListing && (
            <div className={ styles.featuredGalleryCard__organizerBadge }>
              <img
                className={ styles.featuredGalleryCard__organizerBadgeImage }
                src={ organizerAssetUrl }
                alt={ organizerName ? `${organizerName} logo` : 'Organizer logo' }
              />
            </div>
          )
        }

        <h3 className={ titleClassName }>
          { title }
        </h3>

        <span className={ iconClassName }>
          <FontAwesomeIcon
            icon={ faArrowUpRightFromSquare }
            size="2x"
          />
        </span>
      </div>
    </Link>
  )
}
